import MediaItemTags from './MediaItemTags';

export default MediaItemTags;
